import { BiFilter } from 'react-icons/bi';
import { Flex, Text, Box, Menu, MenuButton, MenuList, Divider, Tooltip } from '@chakra-ui/react';
import React, { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ChevronDownIcon } from '@chakra-ui/icons';

import {
  getDashboardBlocks,
  //   getSelectedDashboardScenario,
  //   createInstrument,
  //   updateInstrument,
  //   setEditInstrumentOutput,
  //   setEditInstrumentData,
} from 'redux/DashboardSliceV2';

// import PreviewSelectCheckBox from '../../../components/PreviewFilterCheckBox';
// import PreviewSelectCheckBox from 'components/PreviewFilterCheckBox/MultiSelectCheckBox';

import { findDimensionItems } from './Filters';
import PreviewSelectCheckBox from './MultiSelectCheckBox';

interface Properties {
  widget: any;
  handleApplyFilter: any;
}

const PriviewFilterByComponent = ({ widget, handleApplyFilter }: Properties) => {
  //   const dispatch: any = useDispatch();
  //   const selectedDashboardScenario = useSelector(getSelectedDashboardScenario);
  const blockDetails = useSelector(getDashboardBlocks);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [filterItem, setFilterItem] = useState<any>([]);

  useEffect(() => {
    const data = findDimensionItems(widget, blockDetails);
    setFilterItem(data);
  }, [widget?.instrument_indicators, blockDetails]);
  //   const processedDimensionsData = useMemo(
  //     () =>
  //       widget?.instrument_indicators.map(({ block_id, indicator_id }: any) => {
  //         const foundBlock = blockDetails.find((block: any) => block.block_id === block_id);
  //         const foundIndicator = foundBlock?.indicators?.find(
  //           (indicator: any) => indicator.id === indicator_id,
  //         );
  //         return {
  //           blockid: block_id,
  //           indicatorid: indicator_id,
  //           dimension: foundIndicator?.indicator_dimensions || [],
  //         };
  //       }),
  //     [widget?.instrument_indicators, blockDetails],
  //   );
  const processedDimensionsData = useMemo(() => {
    return widget?.instrument_indicators
      .map(({ block_id, indicator_id, dimension_id }: any) => {
        const foundBlock = blockDetails.find((block: any) => block.block_id === block_id);
        const foundIndicator = foundBlock?.indicators?.find(
          (indicator: any) => indicator.id === indicator_id,
        );
        return {
          blockid: block_id,
          indicatorid: indicator_id,
          dimension:
            foundIndicator?.indicator_dimensions?.filter(
              (dim: any) => dimension_id && dim.indicator_dimension_id === Number(dimension_id),
            ) || [],
        };
      })
      .filter((item: any) => item.dimension.length > 0); // Filter out objects with empty dimension arrays
  }, [widget?.instrument_indicators, blockDetails]);

  const handleApplyFilterFunction = (filterAppliedData: any) => {
    handleApplyFilter(filterAppliedData, filterItem);
    setIsMenuOpen(false);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  //   const handleOpenMenu = () => {
  //     setIsMenuOpen(true);
  //   };

  const renderTooltipContent = () => {
    if (widget?.instrument_type === 'kpi') {
      return (
        <Flex alignItems='center'>
          <Text size={'Roboto-12'} mr={2}>
            Filter By:
          </Text>
          <Divider
            mx={2}
            orientation='vertical'
            size='2xs'
            sx={{
              borderColor: '#706B9A',
            }}
            height='12px'
            alignSelf='center'
          />
          <Text size='Roboto-12' whiteSpace='nowrap'>
            All items
          </Text>
        </Flex>
      );
    }

    return (
      <Flex alignItems='center' gap={2}>
        <Text size={'Roboto-12'}>Filter By:</Text>
        {filterItem &&
          filterItem[0]?.dimensionItems?.map((item: any, index: number) => (
            <React.Fragment key={index}>
              {item && (
                <Flex alignItems='center' key={index}>
                  <Divider
                    mx={2}
                    orientation='vertical'
                    size='2xs'
                    sx={{
                      borderColor: '#706B9A',
                    }}
                    height='12px'
                    alignSelf='center'
                  />
                  <Text size='Roboto-12' whiteSpace='nowrap'>
                    {item.dimensionItemName}
                  </Text>
                </Flex>
              )}
            </React.Fragment>
          ))}
      </Flex>
    );
  };

  return (
    <Menu
      variant={'filter'}
      isOpen={isMenuOpen}
      onClose={() => setIsMenuOpen(false)}
      onOpen={() => setIsMenuOpen(true)}
      strategy='fixed'
      direction={'ltr'}
    >
      <Tooltip
        label={renderTooltipContent()}
        placement='auto-start'
        hasArrow
        maxW='600px'
        bg='white'
        color='black'
        p={4}
        borderRadius='sm'
        boxShadow='0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.1)'
        openDelay={100}
        sx={{
          '--popper-arrow-bg': 'white',
          '--tooltip-bg': 'white',
          '--tooltip-color': 'black',
          '--tooltip-padding': '1rem',
          '--tooltip-border-radius': '0.5rem',
          '--tooltip-shadow':
            '0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.1)',
          '--tooltip-arrow-shadow': '0 4px 6px -1px rgba(0, 0, 0, 0.2)',
          '--tooltip-arrow-size': '8px',
          '--tooltip-arrow-offset': '4px',
        }}
      >
        <MenuButton>
          <Flex
            alignItems={'center'}
            bgColor='#f5f5f5'
            borderRadius='8px'
            p='0.1rem .1rem'
            maxWidth='100%'
          >
            <Box title={'Filter By'}>
              <Flex alignItems='center' cursor='pointer' role='button' tabIndex={0}>
                <BiFilter size={35} color={'#4BB6B9'} />
                <Text size={'Roboto-12'} mr={2}>
                  ({filterItem[0]?.dimensionItems?.length})
                </Text>
              </Flex>
            </Box>
            <Box>
              <ChevronDownIcon fontSize='md' />
            </Box>
          </Flex>
        </MenuButton>
      </Tooltip>
      {/* {isOpen && ( */}
      <MenuList>
        <Flex gap={8} maxW={'600px'} overflowX={'auto'} className='sm-scroll'>
          {processedDimensionsData &&
            processedDimensionsData.length > 0 &&
            [processedDimensionsData[0]]?.map((checkBoxItem: any, index: number) => (
              <React.Fragment key={index}>
                <PreviewSelectCheckBox
                  handleApply={handleApplyFilterFunction}
                  handleClose={handleCloseMenu}
                  checkboxData={checkBoxItem}
                  isMenuOpen={isMenuOpen}
                  filterItem={filterItem}
                />
              </React.Fragment>
            ))}
        </Flex>
      </MenuList>
    </Menu>
  );
};

export default PriviewFilterByComponent;
